import { render } from "./Cube.vue?vue&type=template&id=41e945d3&scoped=true"
import script from "./Cube.vue?vue&type=script&lang=js"
export * from "./Cube.vue?vue&type=script&lang=js"

import "./Cube.vue?vue&type=style&index=0&id=41e945d3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41e945d3"]])

export default __exports__